export enum MessageStatus {
  // Send status
  Queued = 101,
  Encrypted,
  Sent,

  // Receive status
  Summarized = 201,
  Fetched,
  Decrypted,

  // Failed status
  FailedSent = 901,
  FailedEncrypt,
  FailedDecrypt,
  FailedSendFile,
}

export enum LuckyBoxGrabStatus {
  unClaim = 0,
  claimed = 1,
  expired = 2,
  claimedEnd = 3,
}

export enum TransferStatus {
  Failed = 'fail',
  Success = 'success',
  Pending = 'pending',
}

export enum MessageReceiptStatus {
  None = 0,
  Delivered = 1,
  Read = 2,
}

export enum MsgPayloadType {
  // Basic message types
  TEXT = 1, // Text message
  IMAGE = 2, // Image message
  VIDEO = 3, // Video message
  AUDIO = 4, // Audio message
  FILE = 5, // File message
  STICKER = 6, // Sticker message

  // Call related
  MEDIA_AUDIO_CALL = 110, // Initiate voice call
  MEDIA_VIDEO_CALL, // Initiate video call
  CALL_HANG_UP = 112, // Call hung up
  CALL_TIMEOUT, // Call timeout (unanswered)
  CALL_CANCELLED, // Call cancelled by initiator
  CALL_REJECTED, // Call rejected
  CALL_BUSY, // Line busy
  CALL_NETWORK_ERROR, // Call dropped due to network error
  CALL_PUT_THROUGH, // Call connected

  // Group management
  GROUP_CREATE = 201, // Create group
  // GROUP_UPDATE = 202, // Update group info
  GROUP_DISBAND = 203, // Disband group
  GROUP_INVITE = 204, // Invite group members
  GROUP_REMOVE_MEMBER = 205, // Remove group member
  GROUP_MEMBER_QUIT = 206, // Group member quit

  // Group encryption related
  GROUP_ENCRYPTION_WELCOME = 207, // Add member, notify invitee to update welcome
  GROUP_ENCRYPTION_COMMIT = 208, // Member change, notify others to update commit
  GROUP_MEDIA_CLOSE = 209, // media close
  GROUP_UPDATE_JOIN = 210, // Member group join notice
  GROUP_TRANSFER_OWNER = 211, // transfer group owner notice
  GROUP_UPDATE_ADMINS = 212, // update group admins role/group notice
  GROUP_UPDATE_NAME = 213, // update group name notice
  GROUP_UPDATE_DESCRIPTION = 214, // update group description notice
  GROUP_RESTRICTED = 215, // restricted group notice
  GROUP_UNRESTRICTED = 216, // unrestricted group notice
  GROUP_ADMIN_ONLY_SEND = 217, // admin only send message notice
  GROUP_EXCEPTION_SEND = 218, // exception send message notice
  GROUP_JOIN_SUCCESS = 219, // join success notice
  GROUP_RESTRICTED_MODE_ON = 220, // restricted mode on notice
  GROUP_RESTRICTED_MODE_OFF = 222, // restricted mode off notice
  GROUP_RESTRICTED_MODE_OFF_All = 221, // restricted mode off all notice
  GROUP_SCREENSHOT_WARNING = 223, // screenshot warning notice
  GROUP_SCREEN_RECORDING_WARNING = 224, // screen recording warning notice

  // Message operations
  DELETE_MESSAGE = 304, // Delete message

  // Message settings
  EXPIRE_DURATION = 402, // Message expire time

  LUCKY_BOX = 601, // LuckyBox message
  LUCKY_BOX_CLAIMED = 602, // LuckyBox claimed
  TRANSFER = 603, // Transfer message
  TRANSFER_NOTICE = 706, // Transfer message

  CARD = 712, // Card message
}

export enum MessageEditStatus {
  None = 0,
  Editing = 1,
  Edited,
  Failed,
}

export interface MessageEmojiReaction {
  reaction_log: Array<ReactionOperationLog>;
  emoji_id: string;
}

export interface ReactionOperationLog {
  user_id: string;
  operation_at: number;
}

export enum MessageAction {
  NO_ENCRYPT = 1,
  ENCRYPT = 2,
  FORWARD_NO_ENCRYPT = 5,
  FORWARD_ENCRYPT = 6,
}

export enum MsgAtFlag {
  None = 0,
  AtMe = 1,
  AtAll = 2,
}

export interface OriginalMsg {
  at_flag: MsgAtFlag;
  at_list: string;
  at_read_list: string[];
  attach: number;
  cli_msg_id: string;
  created_at: number;
  deleted: number;
  edit: MessageEditStatus;
  edit_completed_at: number;
  send_completed_at: number;
  edit_pending_payload: string;
  expire_duration: number;
  link_msg_id: string;
  message_id: string;
  msg_action: MessageAction;
  owner_id: string;
  payload: string;
  payload_type: MsgPayloadType;
  pin: number;
  pulled: number;
  read_at: number;
  read_state: {
    read_count: number;
    total_count: number;
  };
  receipt_status: MessageReceiptStatus;
  sequence: number;
  local_sequence: number;
  status: MessageStatus;
  sticky: number;
  update_at: number;
  reply_list: string[];
  emoji_reaction?: Array<MessageEmojiReaction>;
  /**
   * msg_ext: {
   *  forwardUid: string;
   * }
   */
  msg_ext: any;
}
